function pageMove(page, scroll_to ){
    $('#page_num').val(page);
    scrollTo( scroll_to );
    const pages_count = $('#pages_count').val();

    let next_button = $('.js-move-page-button[data-type="1"]');
    if(pages_count == page){
        next_button.attr('disabled', 'disabled');
        next_button.data('page', page);
    }else{
        next_button.removeAttr('disabled');
        next_button.data('page', (page+1));
    }

    if(page > 1){
        $('.js-move-page-button[data-type="0"]').data('page', (page-1)).removeAttr('disabled');
    }else{
        $('.js-move-page-button[data-type="0"]').data('page', page).attr('disabled', 'disabled');
    }
    return page;
}

$(document).on('click', '.pagination .js-move-page-button', function(e){
    e.preventDefault();
    $('.pagination .pages .page-number[data-page="' + $(this).data('page') + '"]').click();
});

$(document).on('click', '.js-go-to-page-number', function(e){
    e.preventDefault();
    let page = $(this).data('page');

    if($('#page_num').val() != page){

        $('.pagination .pages .page-number.active').removeClass('active');
        $(this).addClass('active');

        let product_loop = $('#products_loop');
        let scroll_to = '';
        if(product_loop.length){
            scroll_to = product_loop;
        }else{
            scroll_to = $('#blog_loop');
        }

        pageMove(page, scroll_to);
        if(product_loop.length){
            ajax_filter_products(true);
        }else{
            ajax_blog_page(page);
        }
    }
});
